import { type DashRouteType, URL_PARTNER_SCOPED } from '@retailer-platform/dashboard/routing'

export const URL_RECIPES_V2 = `${URL_PARTNER_SCOPED}/recipes/v2`
export const URL_RECIPES_V2_LIST = `${URL_RECIPES_V2}/list`

// Future routes (placeholder for later milestones)
// const URL_RECIPES_V2_CREATE = `${URL_RECIPES_V2}/create`
// const URL_RECIPES_V2_EDIT = `${URL_RECIPES_V2}/edit/:id`
// const URL_RECIPES_V2_VIEW = `${URL_RECIPES_V2}/view/:id`

export type DashRouteSet = DashRouteType<'recipes-v2'> | DashRouteType<'recipes-v2-list'>
// Future route types will be added here

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'recipes-v2': URL_RECIPES_V2,
  'recipes-v2-list': URL_RECIPES_V2_LIST,
}

export type DomainRouteName = keyof typeof routes
